import React from 'react';
import { Typography, Card, Button, Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import { BranchesOutlined, ArrowLeftOutlined } from '@ant-design/icons';

const { Title, Paragraph } = Typography;

export default function AntibodyDenovoPage() {
  const navigate = useNavigate();

  return (

      <div style={{ maxWidth: 800, margin: '0 auto', padding: '24px' }}>
        <Button 
          icon={<ArrowLeftOutlined />} 
          onClick={() => navigate('/structure')}
          style={{ marginBottom: 24 }}
        >
          返回结构与设计
        </Button>
        
        <Card style={{ textAlign: 'center', padding: '48px 24px' }}>
          <BranchesOutlined style={{ fontSize: '72px', color: '#eb2f96', marginBottom: 24 }} />
          
          <Title level={2}>Antibody De novo Design</Title>
          <Title level={4} style={{ color: '#666', fontWeight: 'normal' }}>
            抗体从头设计平台
          </Title>
          
          <Paragraph style={{ fontSize: '16px', margin: '24px 0', color: '#666' }}>
            专业的抗体从头设计平台，支持抗体CDR区优化、亲和力预测和人源化设计等功能。
          </Paragraph>
          
          <div style={{ margin: '32px 0' }}>
            <Title level={5}>主要功能特点：</Title>
            <Space direction="vertical" size="small" style={{ width: '100%' }}>
              <div>🧬 抗体从头设计</div>
              <div>🎯 CDR区优化</div>
              <div>⚡ 亲和力预测</div>
              <div>👤 人源化设计</div>
            </Space>
          </div>
          
          <div style={{ 
            background: '#f0f2f5', 
            padding: '16px', 
            borderRadius: '8px',
            margin: '24px 0'
          }}>
            <Title level={5} style={{ margin: 0, color: '#666' }}>
              🚧 功能开发中，敬请期待
            </Title>
          </div>
        </Card>
      </div>
  );
}